import { xhr } from 'utils/xhr'

const API_BASE = '/featureFlags'

const getAll = () => xhr.get(API_BASE)

export { API_BASE, getAll }
